<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="form-container">
	<dx-form class="m-3" [(formData)]="item" [showColonAfterLabel]="true" labelLocation="top" [colCount]="1">
		<dxi-item itemType="tabbed" [tabPanelOptions]="{hoverStateEnabled:false}">
			<dxo-tab-panel-options [deferRendering]="false"></dxo-tab-panel-options>
			<dxi-tab title="Details">
				<dxi-item dataField="name" [label]="{ text: 'Name' }" [editorOptions]="{ readOnly: true }"></dxi-item>
				<dxi-item dataField="notes" editorType="dxTextArea" [label]="{ text: 'Notes' }" [editorOptions]="{ height: 150 }"></dxi-item>
			</dxi-tab>
			<dxi-tab title="Menu Items">
				<dx-data-grid class="data-grid" [dataSource]="menuItems" [remoteOperations]="false" [allowColumnReordering]="false" [rowAlternationEnabled]="true" [showBorders]="true" height="500px">
					<dxo-paging [pageSize]="100"></dxo-paging>
					<dxo-pager [visible]="false" [showPageSizeSelector]="false" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
					<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
					<dxo-group-panel [visible]="false"></dxo-group-panel>
					<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
					<dxo-export [enabled]="false"></dxo-export>
					<dxi-column dataField="menu.name" dataType="text" alignment="left" caption="Menu"></dxi-column>
					<dxi-column dataField="text" dataType="text" alignment="left" caption="Label"></dxi-column>
					<dxi-column dataField="category" dataType="text" alignment="left" caption="Category"></dxi-column>
					<dxi-column dataField="route" dataType="text" alignment="left" caption="Route"></dxi-column>
					<dxi-column [showEditorAlways]="false" dataField="active" alignment="left" [customizeText]="boolYesNo"></dxi-column>
				</dx-data-grid>
			</dxi-tab>
			<dxi-tab title="Users">
				<dx-data-grid class="data-grid" [dataSource]="groupUsers" [remoteOperations]="false" [allowColumnReordering]="false" [rowAlternationEnabled]="true" [showBorders]="true" height="500px">
					<dxo-paging [pageSize]="100"></dxo-paging>
					<dxo-pager [visible]="false" [showPageSizeSelector]="false" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
					<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
					<dxo-group-panel [visible]="false"></dxo-group-panel>
					<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
					<dxo-export [enabled]="false"></dxo-export>
					<dxi-column *ngIf="isSuperAdmin" type="buttons">
						<dxi-button hint="Remove" icon="fal fa-user-minus" [onClick]="removeUserFromGroup"></dxi-button>
					</dxi-column>
					<dxi-column dataField="id" dataType="text" alignment="left" caption="User"><dxo-lookup [dataSource]="people" valueExpr="userId" displayExpr="fullName"></dxo-lookup></dxi-column>
				</dx-data-grid>
			</dxi-tab>
		</dxi-item>
	</dx-form>
</div>
<dx-popup [width]="'75%'" [height]="600" [showTitle]="true" [title]="popupTitle" [dragEnabled]="false" [closeOnOutsideClick]="false" [showCloseButton]="false" container=".dx-viewport" [(visible)]="popupVisible">
	<dxi-toolbar-item widget="dxButton" toolbar="bottom" location="before" [options]="popupAddButtonOptions"></dxi-toolbar-item>
	<dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="popupCloseButtonOptions"></dxi-toolbar-item>
	<div *dxTemplate="let data of 'content'">
		<dx-form class="m-3" [(formData)]="popupAddUserToGroup" [showColonAfterLabel]="true" labelLocation="top">
			<dxi-item>Are you sure you wish to add this user to the group? This change will be refleacted when they next log in.</dxi-item>
			<dxi-item dataField="userId" editorType="dxSelectBox" [editorOptions]="{ items: dropDownPeople, searchEnabled: true, displayExpr:'fullName', valueExpr:'userId' }" [label]="{ text: 'User' }"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>	
		</dx-form>
	</div>
</dx-popup>